import script from "./CouncilDecision.vue?vue&type=script&setup=true&lang=js"
export * from "./CouncilDecision.vue?vue&type=script&setup=true&lang=js"

import "./CouncilDecision.vue?vue&type=style&index=0&id=1e77b360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e77b360"]])

export default __exports__